import { NavLink } from "react-router-dom";
import { Layout, Space, Button } from "antd";
import viewUtils from "../../../utils/viewUtils";

const Header = (props: any) => {
  return (
    <>
      <Layout.Header className="header-content">
        <div style={{ height: "100%" }}>
          <NavLink to="/system_manage" target="_blank">
            <span className="title">和映官网后台管理</span>
          </NavLink>
        </div>
        <Space className="header-button-list">
          <Button type='primary' onClick={() => viewUtils.logout() }>
            登出
          </Button>
        </Space>
      </Layout.Header>
    </>
  );
};

export default Header;